import gql from "graphql-tag";

export const OC_PROPERTY_SUBSCRIPTION = gql`
  subscription property($resource: String!, $key: String!) {
    property(resource: $resource, key: $key) {
      value
    }
  }
`;
